import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputAdornment,
	TextField,
} from "@mui/material"
import { forwardRef, useContext } from "react"
import { AdminContext } from "../views/Admin"
import { NumericFormat } from "react-number-format"

const Highlighted = ({ text = "", highlight = "" }) => {
	if (!highlight.trim()) {
		return <span>{text}</span>
	}
	const regex = new RegExp(`(${highlight})`, "gi")
	const parts = text.split(regex)

	return (
		<span>
			{parts.filter(String).map((part, i) => {
				return regex.test(part) ? <mark key={part}>{part}</mark> : <span key={part}>{part}</span>
			})}
		</span>
	)
}

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
	const { onChange, ...other } = props

	return (
		<NumericFormat
			{...other}
			getInputRef={ref}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.value,
					},
				})
			}}
			thousandSeparator
			valueIsNumericString
		/>
	)
})

const FakeSaleConfirmationDialog = ({ message, okCallback }) => {
	const adminContext = useContext(AdminContext)
	const fakeSaleConfirmationDialog = adminContext.fakeSaleConfirmationDialog
	const handleFakeSaleConfirmationDialogClose = adminContext.handleFakeSaleConfirmationDialogClose
	const fakeSaleUserId = adminContext.fakeSaleUserId
	const fakeSalePrice = adminContext.fakeSalePrice
	const setFakeSaleUserId = adminContext.setFakeSaleUserId
	const setFakeSalePrice = adminContext.setFakeSalePrice

	const handleOk = () => {
		console.log(fakeSalePrice + " ??? ")
		okCallback(fakeSalePrice, fakeSaleUserId)
		handleFakeSaleConfirmationDialogClose()
	}

	return (
		<Dialog open={fakeSaleConfirmationDialog} onClose={handleFakeSaleConfirmationDialogClose}>
			<DialogTitle>{"אזהרה!"}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Highlighted text={message?.message} highlight={message?.highlight} />
				</DialogContentText>
				<TextField
					label={"מחיר"}
					value={fakeSalePrice}
					onChange={(e) => setFakeSalePrice(e.target.value)}
					size="small"
					sx={{ m: 2, maxHeight: "36px" }}
					InputProps={{
						endAdornment: <InputAdornment position="start">ש״ח</InputAdornment>,
						inputComponent: NumericFormatCustom,
					}}
				/>
				<TextField
					label={"משתמש"}
					value={fakeSaleUserId}
					onChange={(e) => setFakeSaleUserId(e.target.value)}
					size="small"
					sx={{ m: 2, maxHeight: "36px" }}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleFakeSaleConfirmationDialogClose}>ביטול</Button>
				<Button
					onClick={() => handleOk()}
					autoFocus
					disabled={!(!isNaN(parseInt(fakeSalePrice)) && fakeSaleUserId?.length > 0)}
				>
					המשך
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default FakeSaleConfirmationDialog
